module.exports = __webpack_public_path__ + "media/images/new_landing/logos/reknihy-4c82884c180cc8960795138317162cfb.png";